export { DOMAIN } from './domains';
export { EVENTS } from './events';
export { PROPERTY } from './property';

export const APP_INSTANCE_KEY = '1';
